export default class CrudAction {
  static CREATE = 'create';
  static READ = 'read';
  static UPDATE = 'update';
  static DELETE = 'delete';
  static DUPLICATE = 'duplicate';
}